import React from "react";
import { Col, Row } from "reactstrap";
function showOrEmptySection(show, comp) {
  if (show) return comp;
  else return null;
}
export function showFlashingLightSection(FlashingLight) {
  let comp = (
    <React.Fragment>
      <div className="label-text">Flashing Light Units (FRA 234.253) Monthly</div>
      <div className="value-box">{FlashingLight && FlashingLight.condition}</div>
      <div className="comments-text info-section">{FlashingLight && FlashingLight.comments}</div>
    </React.Fragment>
  );
  return showOrEmptySection(FlashingLight && FlashingLight.visible, comp);
}
export function showGateArmSection(GateArms) {
  let comp = (
    <React.Fragment>
      <div className="label-text">Gate Arms & Mechanism (FRA 234.255(ab)) Monthly</div>
      <div className="value-box">{GateArms && GateArms.condition}</div>
      <div className="comments-text info-section">{GateArms && GateArms.comments}</div>
    </React.Fragment>
  );
  return showOrEmptySection(GateArms && GateArms.visible, comp);
}
export function showWarningSystemTime(WarningSystemOperation) {
  let comp = (
    <React.Fragment>
      <div className="label-text">Warning System Operation (FRA 234.257(ab)) Monthly</div>
      <div className="value-box">{WarningSystemOperation && WarningSystemOperation.condition}</div>
      <div className="comments-text info-section">{WarningSystemOperation && WarningSystemOperation.comments}</div>
    </React.Fragment>
  );
  return showOrEmptySection(WarningSystemOperation && WarningSystemOperation.visible, comp);
}

export function showInsulJtsBonds(InsulJtsBonds) {
  let comp = (
    <React.Fragment>
      <div className="border-top-dark">
        <div className="label-text">Insul. Jts., Bonds, & Trk. Conn. (FRA 234.271) Quarterly</div>
        <div className="value-box">{InsulJtsBonds && InsulJtsBonds.condition}</div>
        <div className="comments-text info-section">{InsulJtsBonds && InsulJtsBonds.comments}</div>
      </div>
    </React.Fragment>
  );
  return showOrEmptySection(InsulJtsBonds && InsulJtsBonds.visible, comp);
}
export function showGroundSection(groundData) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Grounds (FRA 234.249) Monthly</div>
      <Col md={6}>
        <div className="box-title">Bus Nomenclature</div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>
      {groundData}
      <hr />
    </React.Fragment>
  );
  return showOrEmptySection(groundData && groundData.length > 0, comp);
}

export function showStandBySection(StandByPower) {
  let comp = (
    <React.Fragment>
      <Col md={12} style={{ marginTop: "15px" }}>
        <div className="label-text">Stand By Power (FRA 234.251) Monthly</div>
        <div className="value-box">{StandByPower && StandByPower.condition}</div>
        <div className="comments-text info-section">{StandByPower && StandByPower.comments}</div>
      </Col>
    </React.Fragment>
  );
  return showOrEmptySection(StandByPower && StandByPower.visible, comp);
}


export function showStandByTable(StandByPower) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Stand By Power (FRA 234.251) Monthly</div>
      <Col md={6}>
        <div className="box-title">Standby Power Nomenclature</div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>

     {StandByPower}
      
      <hr />
    </React.Fragment>
  );
  return showOrEmptySection(StandByPower , comp);
}

export function showFlashingLightTable(FlashingLight) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Flashing Light Units (FRA 234.253) Monthly</div>
      <Col md={6}>
        <div className="box-title">Flashing Light Nomenclature</div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>

     {FlashingLight}
      
      <hr />
    </React.Fragment>
  );
  return showOrEmptySection(FlashingLight , comp);
}


export function showGateArmsTable(GateArm) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Gate Arms & Mechanism (FRA 234.255(ab)) Monthly</div>
      <Col md={6}>
        <div className="box-title">Gate Arm Nomenclature</div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>

     {GateArm}
      
      <hr />
    </React.Fragment>
  );
  return showOrEmptySection(GateArm , comp);
}
export function showTest_Condition_CommentsSection(obj) {
  let comp = obj ? (
    <Row>
      <Col md={12} style={{ marginTop: "15px" }}>
        <div className="label-text">{obj.title}</div>
        <div className="value-box">{obj.condition}</div>
        <div className="comments-text info-section">{obj.comments}</div>
      </Col>
    </Row>
  ) : null;
  return showOrEmptySection(obj && obj.visible, comp);
}

export function showTrafficPremption(TrafficPreEmption) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Traffic Pre-Emption (FRA 234.261) Monthly</div>

      <Col md={6}>
        <div className="box-title">Device Nomenclature</div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>

      {TrafficPreEmption}
    </React.Fragment>
  );
  return showOrEmptySection(TrafficPreEmption && TrafficPreEmption.length > 0, comp);
}
export function showCutOutCircuit(cutOutCircut) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Cut-Out Circuits (FRA 234.269) Quarterly</div>

      <Col md={6}>
        <div className="box-title">Circuit Nomenclature </div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>
      {cutOutCircut}
    </React.Fragment>
  );
  return showOrEmptySection(cutOutCircut && cutOutCircut.length > 0, comp);
}
export function showCNPreemption(CNPreemption) {
  let comp = (
    <React.Fragment>
      <div className="section-heading">Preemption and AAWS (FRA 234.261) Monthly</div>

      <Col md={6}>
        <div className="box-title">Device Nomenclature </div>
      </Col>
      <Col md={6}>
        <div className="box-title">Condition</div>
      </Col>
      {CNPreemption}
    </React.Fragment>
  );
  return showOrEmptySection(CNPreemption && CNPreemption.length > 0, comp);
}



// WEBPACK FOOTER //
// ./src/components/Reports/sims/FRA_Crossing/FRA_CrossingReport/bodyItems.jsx